import React, { useState, useCallback } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';

import { captureException } from '@playbookux/playbook-web-core';
import AudienceTemplate from '../../../components/template-audience';
import typeTemplate from '../../../../core/constants/templateType';

import {
  CREATE_TEMPLATE,
  updateCacheOnCreateTemplate,
} from '../../../../core/graphql/templates';

import {
  Container,
  ModalSave,
  ModalCancel,
} from './styles';

const CreateAudience = (props) => {
  const {
    history,
    companyId,
  } = props;

  const [showModalCancel, setShowModalCancel] = useState(false);
  const [showModalSave, setShowModalSave] = useState(false);
  const [valuesSave, setValuesSave] = useState(null);
  const [error, setError] = useState(false);

  const [
    createTemplate,
    { loading, error: mutationError },
  ] = useMutation(CREATE_TEMPLATE);

  const handleClose = useCallback(() => {
    history.push('/template-library#Audience');
  }, [history]);

  const handleSubmit = useCallback(async () => {
    try {
      await createTemplate({
        variables: {
          projectId: null,
          segmentId: null,
          attributes: {
            companyId,
            ...valuesSave,
          },
        },
        update: updateCacheOnCreateTemplate(typeTemplate.TEMPLATE_AUDIENCE, companyId),
      });

      handleClose();
    } catch (ex) {
      captureException('UPDATE_PARTICIPANTS_NUMBER_FAILED', ex);
      setError(true);
    }
  }, [companyId, createTemplate, handleClose, valuesSave]);

  const handleShowModalSave = useCallback((values) => {
    if (values) {
      setValuesSave(values);
    }
    setError(false);
    setShowModalSave((prev) => !prev);
  }, []);

  const handleShowModalCancel = useCallback(() => {
    setShowModalCancel((prev) => !prev);
  }, []);

  return (
    <>
      <Container>
        <AudienceTemplate
          onCancel={handleShowModalCancel}
          title="Create Saved Audience"
          onSave={handleShowModalSave}
        />
      </Container>

      <ModalSave
        show={showModalSave}
        error={error ? mutationError : null}
        onCancel={handleShowModalSave}
        onConfirm={handleSubmit}
        isLoading={loading}
        textCancel="Cancel"
        textConfirm="Save"
        textContent="Do you want to save your updates?"
      />

      <ModalCancel
        show={showModalCancel}
        onCancel={handleShowModalCancel}
        onConfirm={handleClose}
        isLoading={loading}
        textCancel="No, don't cancel"
        textConfirm="Yes, cancel"
        textContent="Do you want to cancel? Your updates will not be saved."
      />
    </>
  );
};

CreateAudience.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  companyId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  companyId: authentication.company?.id,
});

const enhance = compose(
  connect(mapStateToProps),
);

export default enhance(CreateAudience);
